export default __webpack_public_path__ + "static/media/student-qualification.e9ffe4f8.jpg";